<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>

import VueTypes from "vue-types";

import {ItemBoostAction} from "@/modules/redactor/models/item/boost/ItemBoostAction";

export default {
  name: "r-item-boost-action",
  props: {
    model: VueTypes.instanceOf(ItemBoostAction),
    label: VueTypes.string.def("Action:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemBoostAction.getValues();
    }
  }
}
</script>